<template>
    <div class="overlay" />
</template>

<script>
export default {
    name: 'Overlay',
};
</script>

<style lang="scss">
    /* height: 110% -- dirty hack to prevent that when scrolling down fast
   in mobile devices a gap is shown between the overlay */
    .overlay {
        background-color: $color--negative;
        display: block;
        height: 110%;
        left: 0;
        opacity: 0.8;
        overflow: hidden;
        position: fixed;
        top: 0;
        transition: opacity  0.5s ease-in-out;
        width: 100%;
        z-index: -1;
    }
</style>